module.exports = __webpack_public_path__ + "static/media/arrow-right.11697c70.svg";